/*
 * portl-hover-prefetch.js
 * ──────────────────────────────────────────────────────────────────
 * Hover-prefetch fallback — prefetches the HTML of internal links the
 * user hovers/touches, so the next page can render from cache.
 *
 * Runs ONLY in browsers without Speculation Rules API support
 * (the modern equivalent, registered in layout/theme.liquid). On
 * browsers WITH Speculation Rules, this script early-returns and
 * does nothing — prerender beats prefetch.
 *
 * Save-data + 2G connections skipped to avoid burning quota.
 *
 * Extracted from inline <script> in theme.liquid to a deferred
 * external file — removes ~5-10ms of HTML parse time across every
 * page load.
 * ──────────────────────────────────────────────────────────────────
 */
(function () {
  if (typeof window === 'undefined' || !window.document) return;

  // Skip if Speculation Rules is supported (it handles prerender instead)
  if (window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) return;
  if (navigator.connection && (navigator.connection.saveData ||
      /2g/.test(navigator.connection.effectiveType || ''))) return;

  var prefetched = new Set();
  var hoverTimer = null;
  var HOVER_DELAY = 65; // ms

  function prefetch(url) {
    if (prefetched.has(url)) return;
    prefetched.add(url);
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';
    document.head.appendChild(link);
  }

  function isInternalLink(a) {
    if (!a || a.tagName !== 'A' || !a.href) return false;
    if (a.target === '_blank') return false;
    if (a.hasAttribute('download')) return false;
    if (a.dataset.noPrefetch !== undefined) return false;
    if (a.origin !== location.origin) return false;
    var url = a.pathname || '';
    if (/^\/(cart|checkout|account|admin)/.test(url)) return false;
    return true;
  }

  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest('a');
    if (!isInternalLink(a)) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { prefetch(a.href); }, HOVER_DELAY);
  }, { passive: true });

  document.addEventListener('mouseout', function () {
    clearTimeout(hoverTimer);
  }, { passive: true });

  // Touch users — prefetch immediately on touchstart (no hover)
  document.addEventListener('touchstart', function (e) {
    var a = e.target.closest && e.target.closest('a');
    if (isInternalLink(a)) prefetch(a.href);
  }, { passive: true });
})();
